import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GroupeÉtapesÀLaCarte } from '../models/groupe-étapes-à-la-carte.model';
import { CreateGroupeÉtapesRequest } from '../requests/create-groupe-étapes-request';
import { UpdateGroupeÉtapesRequest } from '../requests/update-groupe-étapes-request';

@Injectable({
  providedIn: 'root',
})
export class GroupeÉtapesService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/groupes-étapes`;

  findById(idGroupe: string): Observable<GroupeÉtapesÀLaCarte> {
    return this.#http.get<GroupeÉtapesÀLaCarte>(this.BASE_URL + '/' + idGroupe);
  }

  créer(data: CreateGroupeÉtapesRequest) {
    return this.#http.post<GroupeÉtapesÀLaCarte>(this.BASE_URL, data);
  }

  modifier(idGroupe: string, data: UpdateGroupeÉtapesRequest) {
    return this.#http.put<{ path: string }>(this.BASE_URL + '/' + idGroupe, data);
  }

  supprimer(id: string) {
    return this.#http.delete(this.BASE_URL + '/' + id);
  }
}
